import { insertExternalImage } from './commands';
export var insertActionForToolbar = function insertActionForToolbar(uploadHandlerReference) {
  return function (state, dispatch) {
    if (!uploadHandlerReference.current) {
      return false;
    }
    uploadHandlerReference.current(undefined, function (options) {
      insertExternalImage(options)(state, dispatch);
    });
    return true;
  };
};